export default {"src":"/_next/static/media/3.82e11bfa.svg","height":105,"width":98,"blurWidth":0,"blurHeight":0};